import i18n from '@/i18n/i18n'
import store from '@/store'
import { OPEN_DIALOG } from '@/store/actions'
import { IActivationCustomField, TError } from 'smartbarcode-web-core/src/utils/types/index'
import { isJson } from './helpers'

export function processError(error: TError, fieldTemplate?: Record<string, string>) {
  const t = i18n.global.t
  let isCustomValidation = false
  let errorDetails
  if (typeof error === 'string') {
    if (isJson(error)) {
      const jsonObject = JSON.parse(error)
      if (jsonObject?.MessageResult) {
        isCustomValidation = true
        errorDetails = jsonObject.MessageResult
      } else {
        errorDetails = t(`errors.${error}`, { ...fieldTemplate })
      }
    } else {
      errorDetails = t(`errors.${error}`, { ...fieldTemplate })
    }
  } else if (error.message) {
    errorDetails = t(`errors.${error.message}`, { ...fieldTemplate })
  } else {
    errorDetails = Object.entries(error)
      .map(([field, value]) => {
        return value
          .map((errorCode: string) => `[ERR.${errorCode}] ` + t(`errors.${errorCode}`, { field: field }))
          .join('<br />')
      })
      .join('<br />')
  }

  return {
    errorDetails: isCustomValidation ? errorDetails : t('error template', { errors: errorDetails }),
  }
}

export function processComparisonError(error: TError, fields: Record<string, IActivationCustomField>) {
  const t = i18n.global.t
  let isCustomValidation = false
  let errorDetails
  if (typeof error === 'string') {
    if (isJson(error)) {
      const jsonObject = JSON.parse(error)
      if (jsonObject?.MessageResult) {
        isCustomValidation = true
        errorDetails = jsonObject.MessageResult
      } else {
        errorDetails = t(`errors.${error}`)
      }
    } else {
      errorDetails = t(`errors.${error}`)
    }
  } else if (error.message) {
    errorDetails = t(`errors.${error.message}`)
  } else {
    errorDetails = Object.entries(error)
      .map(([field, value]) => {
        return value
          .map((errorCode: string) => {
            let val1 = ''
            switch (errorCode.toString()) {
              case '1007':
                val1 = fields[field]?.minValue?.toString() ?? ''
                break
              case '1009':
                val1 = fields[field]?.maxValue?.toString() ?? ''
                break
            }
            return `[ERR.${errorCode}] ` + t(`errors.${errorCode}`, { field: field, val1: val1 })
          })
          .join('<br />')
      })
      .join('<br />')
  }

  return {
    errorDetails: isCustomValidation ? errorDetails : t('error template', { errors: errorDetails }),
  }
}

export function errorComparisonHandler(error: TError, fields: Record<string, IActivationCustomField>) {
  const { errorDetails } = processComparisonError(error, fields)
  store.dispatch(OPEN_DIALOG, {
    message: errorDetails,
  })
}

export default function errorHandler(error: TError, fieldTemplate?: Record<string, string>) {
  const { errorDetails } = processError(error, fieldTemplate)

  store.dispatch(OPEN_DIALOG, {
    message: errorDetails,
  })
}
